const CustomCheckbox = {


	init: () => {
		CustomCheckbox.initOnChange();
	},


	initOnChange: () => {
		const checkboxes = document.querySelectorAll(`.custom-checkbox-js input`);
		checkboxes.forEach((checkbox) => {
		    checkbox.addEventListener('change', (ev) => {
				const parent = checkbox.closest('.custom-checkbox-js');
				parent.classList.toggle('checked', checkbox.checked);
			});
		})
	}


}
export default CustomCheckbox;
